class StartUsersController {
    static controller($scope, $state, $localStorage, LoginService, authService) {
        'ngInject';
    }
}

export default StartUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/start.users.controller.js